import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { CurrencyComponent, DateComponent } from '@web/shared/ui';
import { PublicCartRecursive } from '@web/shared/module/shop';

@Component({
  selector: 'app-public-order-summary-recursive-info',
  imports: [CurrencyComponent, DateComponent],
  templateUrl: './public-order-summary-recursive-info.component.html',
  styleUrl: './public-order-summary-recursive-info.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicOrderSummaryRecursiveInfoComponent {
  public readonly recursive = input.required<PublicCartRecursive[]>();
}
